module.exports = __webpack_public_path__ + "static/media/19_TOP_FRENTE_UNICA_COM_BOJO_ESTAMPADO_01.7055ce77.jpg";